import React from 'react';
import ExtraSection from './ExtraSection';
import AuthService from '../../services/auth-service';
import InputPassword from '../widgets/input-password/InputPassword';

import './Login.scss';

const particleConfig = require('./particlesjs-config.json');

export interface ResetPasswordState {
  password: string;
  confirmPassword: string;
  error: string
}

class ResetPassword extends React.Component<any, ResetPasswordState> {

  authService = new AuthService();

  state = {
    password: '',
    confirmPassword: '',
    error: ''
  }

  render() {
    return (
      <div className="login-page-component" id="particle-div">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-12 mx-auto login-card-container">
              <div className="login-card">
                <div className="row h-100 w-100 mx-0">
                  <div className="col-lg-6 col-12 h-100">
                    <form className="login-form">
                      <h1 className="login-title">تغییر رمز عبور</h1>
                      <div className="form-group" style={{ fontSize: '0.9rem', color: '#16a085', padding: '0 1rem' }}>
                        برای وارد شدن به سیستم باید یک رمز جدید تعیین کنید
                      </div>
                      <InputPassword
                        autoFocus
                        placeholder="رمز عبور"
                        onKeyDown={this.handleKeyDown}
                        onChange={this.handlePasswordChange}
                      />
                      <InputPassword
                        placeholder="تکرار رمز عبور"
                        onKeyDown={this.handleKeyDown}
                        onChange={this.handleConfirmPasswordChange}
                      />
                      {(this.state.error === null) ? '' :
                        <div className="form-group text-danger text-center" style={{ fontSize: '0.9rem' }}>
                          {this.state.error}
                        </div>
                      }
                      <div className="form-group">
                        <button
                          onClick={this.tryResetPassword}
                          className="btn btn-block btn-success">تغییر رمز عبور</button>
                      </div>
                    </form>
                  </div>
                  <ExtraSection />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    (window as any).particlesJS('particle-div', particleConfig, () => {
      console.log('Particles Load');
    });
  }

  handlePasswordChange = (e: any) => {
    this.setState({ password: e.target.value });
  }

  handleConfirmPasswordChange = (e: any) => {
    this.setState({ confirmPassword: e.target.value });
  }

  handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      this.tryResetPassword(e);
    }
  }

  private tryResetPassword = async (e: any) => {
    e.preventDefault();
    const password = this.state.password;
    const confirmPassword = this.state.confirmPassword;
    if (password !== confirmPassword) {
      return this.setState({ error: 'رمز عبور و تکرار آن با هم مطابقت ندارند' })
    }
    try {
      const response = await this.authService.resetPassword(password);
      if (response && response.token) {
        window.localStorage.setItem('token', response.token);
        window.location.href = '/dashboard';
      }
      else {
        return this.setState({ error: 'مشکلی در اتصال به سرور وجود دارد' })
      }
    }
    catch(e) {
      return this.setState({ error: 'مشکلی در اتصال به سرور وجود دارد' })
    }
  }

}

export default ResetPassword;
